import _ from 'lodash';
import '../../styles/DashboardNavigation';
import React, { PropTypes } from 'react';

const DashboardNavigation = React.createClass({
	propTypes: {
		disabled: PropTypes.bool,
		observation: PropTypes.object.isRequired,
		router: PropTypes.object.isRequired
	},

	getStudentOptions: function() {
		let studentIds = [],
			students = [],
			options = [];

		this.props.observation.student_observations.map((studentObservation) => {
			if (!studentIds.includes(studentObservation.student_id)) {
				studentIds.push(studentObservation.student_id);

				if (studentObservation.student) {
					students.push(studentObservation.student);
				}
			}
		});

		_.sortBy(students, 'first_name').map((student) => {
			options.push(
				<option
					key={ 'dashboard-navigation-student-' + student.id }
					value={ '/dashboard/' + this.props.observation.id + '/students/' + student.id }
				>
					Details: { student.first_name + ' ' + student.last_name }
				</option>
			);
		});

		return options;
	},

	render: function() {
		return (
			<div className="dashboard-navigation">
				<div className="form-group">
					<label>Navigate</label>
					<select
						className="form-control"
						disabled={ this.props.disabled === true }
						onChange={ (ev) => this.props.router.push(ev.target.value) }
						value={ window.location.pathname }
					>
						<option value="" disabled>-- OVERVIEW --</option>
						<option value={ '/dashboard/' + this.props.observation.id }>  Overview</option>
						<option value="" disabled>-- STUDENTS --</option>
						<option value={ '/dashboard/' + this.props.observation.id + '/students' }>Student Overview</option>
						{ this.getStudentOptions() }
						<option value="" disabled>-- TEACHER --</option>
						<option value={ '/dashboard/' + this.props.observation.id + '/teacher' }>Teacher Overview</option>
					</select>
				</div>
			</div>
		);
	}
});

module.exports = DashboardNavigation;



// WEBPACK FOOTER //
// ./frontend/olos/js/components/DashboardNavigation.jsx